/* eslint-disable */
import apiConfig from '../../../config/api';

const getApiPath = () => (apiConfig[`${PROCESS_ENV || 'DEV'}_API_ROOT`]);

export default getApiPath;
